<template>
<div class="view view-checkout">
    <top-bar v-if="isPortalReady" />
    <div class="site-content"
        v-show="isVisible">
        <div class="container">
            <h1 class="checkout-pick">Pago Móvil</h1>
            <div class="row checkout-options">
                <div class="col-6">
                    <div class="row">
                        <div class="col">
                            <img :src="curso.foto" alt="">
                        </div>
                        <div class="col">
                            <h3 v-html="curso.categoria"></h3>
                            <h4 v-html="curso.autor"></h4>
                            <p>$24.990</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <site-footer v-if="isPortalReady"/>
</div>
</template>

<script>
import { mapState } from "vuex";
import TopBar from "../components/TopBar";
import SiteFooter from "../components/SiteFooter";
import Spinner from "../components/Spinner";
import { getCategoriaDeProducto } from "../utilities/data";

export default {
	name: "checkout-movil",
	components: {
		TopBar,
		SiteFooter,
		Spinner
	},
	head: {
		title() {
			return {
				inner: this.curso.categoria
			};
		}
	},
	computed: {
		curso() {
			return this.portal.productos_portal
				? getCategoriaDeProducto(
						this.portal,
						this.$route.params.id_producto
				  )
				: {};
		},
		pasarelasNoMoviles() {
			return this.portalPasarelas.filter(
				pasarela => pasarela.is_movil == 0
			);
		},
		pasarelasMoviles() {
			return this.portalPasarelas.filter(
				pasarela => pasarela.is_movil == 1
			);
		},
		...mapState(["portal", "isPortalReady"])
	},
	watch: {
		portal(val, old) {
			if (val)
				if (typeof val.productos_portal !== "undefined") this.start();
		}
	},
	data() {
		return {
			selectedPortalPasarela: {},
			isVisible: false,
			portalPasarelas: [],
			isLoadingPagoUrl: false,
			pagandoMovil: false,
			numeroConfirmado: false
		};
	},
	methods: {
		setPortalPasarela(portalPasarela) {
			this.selectedPortalPasarela = portalPasarela;
		},
		pagar() {
			this.isLoadingPagoUrl = true;
			// Es pago con postback
			if (!this.selectedPortalPasarela.is_movil) {
				this.$api
					.getPagoUrl({
						id_producto: this.$route.params.id,
						id_portal_pasarela: this.selectedPortalPasarela
							.id_portal_pasarela,
						id_moneda: this.selectedPortalPasarela.pasarela
							.monedas[0].id
					})
					.then(response => {
						this.isLoadingPagoUrl = false;
						//window.location = response.data.response;
					});
			} else {
				// Es pago móvil
				this.$router.push({
					name: "checkout-movil",
					id_producto: this.$route.params.id,
					id_portal_pasarela: this.selectedPortalPasarela.id
				});
			}
		},
		start() {
			if (
				this.portal.productos_portal.filter(
					producto => producto.id == this.$route.params.id_producto
				).length > 0
			) {
				// Cargar pasarelas del producto/portal
				this.portalPasarelas = this.portal.productos_portal
					.filter(
						producto =>
							producto.id == this.$route.params.id_producto
					)[0]
					.productos_pasarelas.map(pp => {
						return {
							id_portal_pasarela: pp.id_portal_pasarela,
							pasarela:
								pp.productos_portal_pasarela[0].pasarelas[0]
						};
					});

				if (this.portalPasarelas.length > 0)
					this.selectedPortalPasarela = this.portalPasarelas[0];
			} else {
				// El id del curso no existe.
				this.$router.replace({ name: "error404" });
			}
			this.isVisible = true;
		}
	},
	mounted() {
		if (this.portal.productos_portal) this.start();
	}
};
</script>

